import { ExclamationCircleFilled } from "@ant-design/icons";
import { App, Modal } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  cancelDelete,
  downloadFile,
  forceDelete,
} from "store/bailiff/client/client.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

const { confirm } = Modal;
export const useBailiffDownload = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleDownload = ({ id, generateDocx = () => {} }) => {
    if (!id) return message.error("Lỗi không xác định, xin vui lòng thử lại.");
    setLoading(true);
    dispatch(
      downloadFile({ id }, (res) => {
        setLoading(false);
        if (res?.status === 500) {
          message.error(res?.data);
        }
        if (res?.status === 200) {
          generateDocx();
        }
      }),
    );
  };

  // force delete.
  const handleForceDelete = ({ id }) => {
    confirm({
      title: "Bạn chắn chắn muốn xoá file?",
      icon: <ExclamationCircleFilled />,
      content:
        "Sau khi thực thi lệnh này, file sẽ xoá vĩnh viễn sau 10 phút. Tác vụ này không thể phục hồi",
      onOk() {
        confirmForceDelete({ id });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const confirmForceDelete = ({ id }) => {
    setLoadingDelete(true);
    dispatch(
      forceDelete({ id }, (res) => {
        setLoadingDelete(false);
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  // cancel delete.
  const handleCancelDelete = ({ id }) => {
    confirm({
      title: "Bạn muốn khôi phục file?",
      icon: <ExclamationCircleFilled />,
      content:
        "Sau khi thực thi lệnh này, file sẽ được trả ngược về trạng thái có thể cho tải, nhưng 24h sau vẫn sẽ bị hệ thống tự động xoá ra khỏi cơ sở dữ liệu",
      onOk() {
        confirmCancelDelete({ id });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const confirmCancelDelete = ({ id }) => {
    setLoadingCancel(true);
    dispatch(
      cancelDelete({ id }, (res) => {
        setLoadingCancel(false);
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    handleDownload,
    loadingDelete,
    handleForceDelete,
    loadingCancel,
    handleCancelDelete,
  };
};
